/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import iconhome from '../../../img/admin/icon-home.png';
import arrImage from '../../../img/admin/arr.png';

function HeaderTitle({varMenuTitle,varPageTitle}){

  return(
    <div className="tit">
      <div className="title">{varPageTitle}</div>
      <div className="path">
        <img src={iconhome} alt=""/>
        HOME<img src={arrImage} alt=""/>{varMenuTitle}<img src={arrImage} alt=""/>{varPageTitle}
      </div>
    </div>
  );
}

export default HeaderTitle;
